/** Должно совпадать с backend/src/utils/chatContactLeak.js (локальная часть). */

export const CHAT_CONTACT_BLOCKED_MESSAGE =
  'По правилам платформы общение разрешено только внутри приложения. Нельзя передавать телефон, почту, ник в Telegram и другие контакты для общения вне биржи.';

function normalizeChatText(s: string): string {
  return String(s || '')
    .replace(/\uFEFF/g, '')
    .replace(/\uFF03/g, '@')
    .replace(/[\u200B-\u200D]/g, '');
}

function expandRussianDigitWords(s: string): string {
  let t = String(s);
  const pairs: [string, string][] = [
    ['нуль', '0'],
    ['ноля', '0'],
    ['ноль', '0'],
    ['один', '1'],
    ['одна', '1'],
    ['два', '2'],
    ['две', '2'],
    ['три', '3'],
    ['четыре', '4'],
    ['пять', '5'],
    ['шесть', '6'],
    ['семь', '7'],
    ['восемь', '8'],
    ['девять', '9']
  ];
  for (const [w, d] of pairs) {
    const re = new RegExp(`(?<![а-яёА-ЯЁ])${w}(?![а-яёА-ЯЁ])`, 'gi');
    t = t.replace(re, d);
  }
  return t;
}

const SPELLED_DIGIT_RE =
  /(?<![а-яёА-ЯЁ])(?:нуль|ноль|ноля|один|одна|два|две|три|четыре|пять|шесть|семь|восемь|девять)(?![а-яёА-ЯЁ])/gi;

function countSpelledDigitWords(raw: string): number {
  return (String(raw).match(SPELLED_DIGIT_RE) || []).length;
}

function hasExplicitPhoneShare(raw: string): boolean {
  return /(?:мой|вот|это)\s+номер|\bномер\s+телефона\b|\bтелефон\b|позвон(?:и|ите|ю)|скинь\s+номер/i.test(
    raw
  );
}

function digitsLookLikeRuMobile(digits: string): boolean {
  if (!digits || digits.length < 10) return false;
  for (let i = 0; i <= digits.length - 11; i++) {
    const w = digits.slice(i, i + 11);
    if (/^[78]9\d{9}$/.test(w)) return true;
  }
  for (let i = 0; i <= digits.length - 12; i++) {
    const w = digits.slice(i, i + 12);
    if (/^380\d{9}$/.test(w) || /^375\d{9}$/.test(w)) return true;
  }
  return false;
}

function hasOffPlatformMessengerIntent(raw: string): boolean {
  if (
    /(?:^|[\s,.:;!«"'\n(—-])(?:давай|ид[её]м|перейд[её]м|напиши|пиши|звони|позвони|скинь)(?:\s+мне)?\s+(?:на\s+|в\s+)?(?:ватсап|вотсап|whatsapp|вайбер|viber|телеграм|дискорд|discord)/i.test(
      raw
    )
  ) {
    return true;
  }
  if (
    /(?:^|[\s,.:;!«"'\n(—-])(?:на\s+ватсап|в\s+ватсап|в\s+ватсапе|на\s+вотсап|на\s+whatsapp)/i.test(
      raw
    )
  ) {
    return true;
  }
  if (/(?:^|[\s,.:;!])(?:в\s+тг\b|в\s+личк[ау]|в\s+телеграм|в\s+телег[еу]|на\s+тг\b)/i.test(raw)) {
    return true;
  }
  return false;
}

/** Быстрый префлайт перед POST — тот же смысл, что hasLocalContactLeak на сервере. */
export function hasBlockedContact(text: string): boolean {
  const raw = normalizeChatText(text);
  if (!raw.trim()) return false;

  if (/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/i.test(raw)) return true;
  if (/\(\s*собака\s*\)|\(\s*at\s*\)|\[\s*at\s*\]|\s+собака\s+\S+\s+точка\s+/i.test(raw)) return true;

  if (/t\.me\/|telegram\.me\/|tg:\/\/|wa\.me\/|whatsapp\.com\/|viber:\/\//i.test(raw)) return true;

  if (/(?:^|[\s,.:;!«"'\n(])@[a-zA-Z][a-zA-Z0-9_]{4,31}(?![a-zA-Z0-9_])/u.test(raw)) return true;

  if (
    /(?:^|[\s,.:;!«"'\n(])(?:собака|собачка|собачки|собачку)\s+[a-zA-Z][a-zA-Z0-9_]{4,31}(?![a-zA-Z0-9_])/iu.test(
      raw
    )
  ) {
    return true;
  }

  if (
    /(?:^|[\s,.:;!«"'\n()—-])(?:тг|телег[ау])\s+[a-zA-Z][a-zA-Z0-9_]{4,31}(?![a-zA-Z0-9_])/iu.test(
      raw
    )
  ) {
    return true;
  }

  if (hasOffPlatformMessengerIntent(raw)) return true;

  const digitsPlain = raw.replace(/\D/g, '');
  if (digitsLookLikeRuMobile(digitsPlain)) return true;

  const digitsExpanded = expandRussianDigitWords(raw).replace(/\D/g, '');
  if (digitsLookLikeRuMobile(digitsExpanded)) return true;

  const spelled = countSpelledDigitWords(raw);
  if (spelled >= 2 && digitsExpanded.length >= 10) return true;
  if (hasExplicitPhoneShare(raw) && digitsExpanded.length >= 6) return true;

  return false;
}
